import { render, staticRenderFns } from "./widget-children-message.vue?vue&type=template&id=f042af86&"
import script from "./widget-children-message.vue?vue&type=script&lang=js&"
export * from "./widget-children-message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports